import { DocumentNode, gql } from '@apollo/client'

export const ADD_PARENT: DocumentNode = gql`
    mutation AddParent($daycare_id: Int!, $email_parent: String!, $from_suggest: Boolean) {
        addParent(daycare_id: $daycare_id, email_parent: $email_parent, from_suggest: $from_suggest)
    }
`

export const DETACH_PARENT_MUTATION: DocumentNode = gql`
    mutation dissociate($daycare_id: Int!, $parent_id: Int!) {
        dissociate(daycare_id: $daycare_id, parent_id: $parent_id)
    }
`

export const BULK_DETACH_PARENT_MUTATION: DocumentNode = gql`
    mutation bulkDissociate($daycare_id: Int!, $parent_ids: [Int!]) {
        bulkDissociate(daycare_id: $daycare_id, parent_ids: $parent_ids)
    }
`
